import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { snackActions } from '@/components/snackbarUtils/SnackbarUtils'
import { handleApiError } from './helpers'
import {
  VerifySignupBody,
  RequestChangePasswordBody,
  LoginBody,
  LoginResponse,
} from '@backend/auth/authRouter'

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: fetchBaseQuery({
    baseUrl: window.env.API_ENDPOINT,
  }),
  endpoints: (builder) => ({
    verifySignup: builder.query<void, VerifySignupBody>({
      query: ({ password, token }) => ({
        url: 'auth/verify-signup',
        method: 'POST',
        body: {
          password,
          token,
        },
      }),
      async onQueryStarted(_id, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (err) {
          handleApiError('api.auth.errors.verifySignup', err)
        }
      },
    }),
    requestChangePassword: builder.query<void, RequestChangePasswordBody>({
      query: ({ email }) => ({
        url: 'auth/request-change-password',
        method: 'POST',
        body: {
          email,
        },
      }),
      async onQueryStarted(_id, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (err) {
          handleApiError('api.auth.errors.requestChangePassword', err)
        }
      },
    }),
    changePassword: builder.query<void, VerifySignupBody>({
      query: ({ password, token }) => ({
        url: 'auth/change-password',
        method: 'POST',
        body: {
          password,
          token,
        },
      }),
      async onQueryStarted(_id, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (err) {
          handleApiError('api.auth.errors.changePassword', err)
        }
      },
    }),
    login: builder.query<LoginResponse, LoginBody>({
      query: ({ email, password }) => ({
        url: 'auth/login',
        method: 'POST',
        body: {
          email,
          password,
        },
      }),
      async onQueryStarted(_id, { queryFulfilled }) {
        try {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('userId')
          localStorage.removeItem('userName')
          localStorage.removeItem('userRole')
          const result = await queryFulfilled

          const { accessToken, id, firstName, userRole, schemaIds } =
            result.data
          localStorage.setItem('accessToken', accessToken)
          localStorage.setItem('userId', id.toString())
          localStorage.setItem('userName', firstName)
          localStorage.setItem('userRole', userRole)
          localStorage.setItem('schemaIds', JSON.stringify(schemaIds))
        } catch {
          snackActions.error('api.auth.errors.login')
        }
      },
    }),
  }),
})

export const {
  useLazyVerifySignupQuery,
  useLazyRequestChangePasswordQuery,
  useLazyChangePasswordQuery,
  useLazyLoginQuery,
} = authApi
